"use client";

import { useAuth } from "@app/_context/authContext";

import LoginView from "./LoginView";
import ResetView from "./ResetView";

export default function LoginCard() {
  const { auth } = useAuth();
  if (auth?.reset) return <ResetView />;
  return <LoginView />;
}
